<template>
  <BModal
    :modal-name="modalName"
    full
  >
    <LeadImportModal
      :title="$t('import.excel.title')"
      :modal-name="modalName"
      accept-data-type=".xlsx"
    />
  </BModal>
</template>

<script>
import LeadImportModal from '@/components/organisms/user/leadList/modal/LeadImportModal.vue';

export default {
  components: {
    LeadImportModal,
  },
  computed: {
    modalName () {
      return 'ExcelImportModal';
    },
  },
};
</script>
